import { InjectionToken } from '@angular/core';

export const DEFAULT_ERROR_MESSAGES: Record<string, string | Record<string, string>> = {
  required: 'forms.required_l',
  email: 'forms.invalid_email_l',
  fileMaxSize: 'forms.max_file_exceeded_l',
  ngbDate: {
    invalid: 'forms.invalid_date_l',
  },
  invitationCode: {
    notExisting: 'registration_wrong_invitation_code_l',
    invalid: 'registration_outdated_invitation_code_l',
  },
  sameValueRequired: 'forms.same_value_required_l',
  invalidName: 'forms.invalid_name_l',
  invalidPhoneNumber: 'forms.invalid_phone_number_l',
  invalidPhonePrefix: 'forms.invalid_phone_prefix_l',
  invalidZipcode: 'forms.invalid_zipcode_l',
  minlength: 'forms.minlength_l',
  maxlength: 'forms.maxlength_l',
  onlyNumbers: 'forms.only_numbers_l',
  invalidIban: 'forms.invalid_iban_l',
  hasLowerUpperCase: 'pw-check.error.pw-has_lower_upper_case',
  hasNumberSpecial: 'pw-check.error.pw-has_number_special',
  hasAll: 'pw-check.error.pw-has_all',
  minLength: 'pw-check.error.pw-min_length',
  isNotMatching: 'register.password_repeat_invalid_l',
  invalidEmail: 'forms.errors.value_does_not_match_email',
  invalidLastname: 'forms.errors.invalid_lastname_l',
};

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => DEFAULT_ERROR_MESSAGES,
});
